import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ResponseAvmData } from '../../models/response-avm-data';

@Component({
  selector: 'app-response-nearby-api',
  standalone: true,
 imports: [CommonModule],
  templateUrl: './response-nearby-api.component.html',
  styleUrl: './response-nearby-api.component.scss'
})
export class ResponseNearbyApiComponent {

 @Input() response: any | null = [];

  ngOnChanges(){
  
  }
}
